/* global Silverlight */
/* global SkinUtils */

var NeonPlayerSilverlight = function () {
	var _container = "",
		_silverlightPlayerElement = undefined,
		_settings = undefined,

		createSilverlightPlayer = function (container, settings) {
			
			_settings = settings;
			_container = container;
			
			// Calculate silverlight player path
			var scriptName = "sfa-player";
			var unbundledScriptName = "NeonPlayer";
			var jsFileLocation = $("script[src*=" + scriptName + "]").attr("src");
			if(!jsFileLocation) {
				jsFileLocation = $("script[src*=" + unbundledScriptName + "]").attr("src");
			}
			var jsLocationTmp = jsFileLocation.split("/");
			jsLocationTmp.pop();
			jsFileLocation = jsLocationTmp.join("/");
			
			if(jsFileLocation.indexOf("//") === 0 || jsFileLocation.indexOf("\\") === 0) {
				// Add protocol to protocol-less URL to avoid Silverlight bug handling this URLs in OSX
				jsFileLocation = location.protocol + jsFileLocation;
			}
			
			_settings.silverlightPath = jsFileLocation + "/silverlight/";
				
			Silverlight.createObject(
				_settings.silverlightPath + "Mini.xap",
				container,
				"mini",
				{
					width: 1,
					height: 1,
					background: "transparent",
					version: "4.0.50917",
					windowless: "true",
					minRuntimeVersion: "4.0.50917",
					autoUpgrade: "true"
				},
				{},
				"",
				{}
			);
			
			if (_settings.debug) window.console && console.log("Silverlight player created");
		},

		startPlayback = function (media) {
			if (_settings.debug) window.console && console.log("Silverlight playback starting");
			
			
			if(!media.smoothManifest) {
				throw "Smooth manifest not defined. The player requires Smooth for playback in the given context (browser, etc) and no manifest has been provided.";
			}
			
			var createPlayerElement = function (context) {
				var params = {
					width: _settings.width,
					height: _settings.height,
					background: "transparent",
					version: "4.0.50917",
					enableHtmlAccess: "true",
					windowless: "true",
					minruntimeversion: "4.0.50917",
					autoupgrade: "true",
					althtml: '<a style="text-decoration: none;" href="http://go.microsoft.com/fwlink/?LinkID=149156&amp;v=3.0.40818.0"><img alt="Get Microsoft Silverlight" src="http://go.microsoft.com/fwlink/?LinkId=161376"></a>',
				};

				if (_settings.debug) window.console && console.log("Silverlight version " + params.version + (Silverlight.isInstalled(params.version) ? " is installed" : " is not installed"));

				Silverlight.createObject(
					_settings.silverlightPath + "MediaPlayer.SmoothStreaming.xap",
					_container,
					"silverlightControl",
					params,
					{
						onError: onSilverlightError,
						onLoad: onSilverlightLoaded
					},
					"",
					context
				);
				
			},
			
			onSilverlightError = function (sender, args) {
				if (_settings.debug) window.console && console.log("Silverlight error");
			},
			
			onSilverlightLoaded = function (sender, context) {
				var playReadyUrl = _settings.smoothLicenserUrl;
				var features = SkinUtils.getFeatures(_settings.skin);

				_silverlightPlayerElement = document.getElementById("silverlightControl");
				_silverlightPlayerElement.Content.MainPage.SetDebug(_settings.debug);
				// Close button at the top right corner (custom)
				_silverlightPlayerElement.Content.MainPage.SetCloseButton(features.indexOf("closeButton") > -1);
				_silverlightPlayerElement.Content.MainPage.SetMedia(
					true, context.mediaId, context.customerToken, context.videoTitle, context.language, "", context.smoothManifest, "", "", "", "", playReadyUrl, true, false);

				if (context.subtitles !== undefined && context.subtitles != {}) {
					var keys = Object.keys(context.subtitles);
					if (keys.length > 0) {
						var subtitlesLanguageSection = context.subtitles[context.language];
						if(subtitlesLanguageSection) {
							var subtitlesUrl = subtitlesLanguageSection.urls.sami;
							if(subtitlesUrl && subtitlesUrl.length > 0) {
								_silverlightPlayerElement.Content.MainPage.SetSubtitlesURL(subtitlesUrl);
							}
						}
					}
				}
							
				_silverlightPlayerElement.Content.MainPage.RegisterCallback("onStateChanged", "onStateChanged");
				_silverlightPlayerElement.Content.MainPage.RegisterCallback("onToggleFullscreen", "onToggleFullscreen");
				_silverlightPlayerElement.Content.MainPage.RegisterCallback("onError", "onError");
							
				if (_settings.debug) window.console && console.log("Silverlight loaded");  
			};
			
			createPlayerElement(media);
		},

		closeSilverlightPlayer = function () {
			try {
				_silverlightPlayerElement.Content.MainPage.Stop();
			} catch (a) {
				return;
			}
			$("#playerContainer").empty();
			
			if (_settings.debug) window.console && console.log("Silverlight player closed");
		};

	return {
		createPlayer: function (container, options) {
			createSilverlightPlayer(container, options);
		},

		startPlayback: function (media) {
			startPlayback(media);
		},

		play: function () {
			_silverlightPlayerElement.Content.MainPage.Play();
		},

		pause: function () {
			_silverlightPlayerElement.Content.MainPage.Pause();
		},
		
		close: function () {
			closeSilverlightPlayer();
		},
		
		seek: function (seconds) {
			_silverlightPlayerElement.Content.MainPage.SetPosition(seconds * 1000);
		},

		getCurrentTime: function () {
			return _silverlightPlayerElement.Content.MainPage.GetPosition() / 1000;
		},
		
		getDuration: function () {
			return _silverlightPlayerElement.Content.MainPage.GetDuration();
		}
	};
};

var startTimeSeekDone = false;

var onStateChanged = function (state) {
	var playbackEvents = {
		"Opening": "starting",
		"Playing": "playing",
		"Paused": "paused",
		"Finished": "ended"
	};
    
	if(playbackEvents[state] === undefined) return;
	$(document).trigger("playbackEvent", {sender: "Silverlight", detail: playbackEvents[state]});
};

var onToggleFullscreen = function (isFullscreen) {
	var mode = isFullscreen ? "fullscreen" : "windowed";
	$(document).trigger("fullscreenEvent", {sender: "Silverlight", detail: mode});	
};

var onError = function () {
	//TODO: fix error detail.
	$(document).trigger("errorEvent", {sender: "Silverlight", detail: "error"});	
};

// Function called by the silverlight player when the close button is clicked
// NOTE: The dummy variable is needed in IE for some reason
function CloseShadowbox(myVar) {
	$(document).trigger("closingEvent", {sender: "Silverlight", detail: "ending"});
}
